<!--template>
  <vue-perfect-scrollbar
    class="scroll-area"
    v-once
    :settings="settings"
    @ps-scroll-x="scrollX(...arguments)"
    @ps-scroll-left="scrollLeft(...arguments)"
    @ps-scroll-right="scrollRight(...arguments)"
    @ps-scroll-y="scrollY(...arguments)"
    @ps-scroll-up="scrollUp(...arguments)"
    @ps-scroll-down="scrollDown(...arguments)"
    @ps-y-reach-start="$emit('y-start')"
    @ps-y-reach-end="$emit('y-end')">
    <slot></slot>
  </vue-perfect-scrollbar>
</template-->
<!--template>
  <vue-perfect-scrollbar
    class="scroll-area"
    v-once
    :settings="settings"
    @ps-scroll-x="scrollX(...arguments)"
    @ps-scroll-left="scrollLeft(...arguments)"
    @ps-scroll-right="scrollRight(...arguments)"
    @ps-scroll-up="scrollUp(...arguments)"
    @ps-scroll-down="scrollDown(...arguments)"
    @ps-y-reach-start="$emit('y-start')"
    @ps-y-reach-end="$emit('y-end')">
    <slot></slot>
  </vue-perfect-scrollbar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: { VuePerfectScrollbar },
  data () {
    return {
      settings: {
        minScrollbarLength: 10,
        maxScrollbarLength: 60
      },
      timestamps: {
        y: null,
        up: null,
        down: null
      }
    }
  },
  methods: {
    scrollX (event) {
      this.scroll('x', event)
    },
    scrollLeft (event) {
      this.scroll('left', event)
    },
    scrollRight (event) {
      this.scroll('right', event)
    },
    scrollY (event) {
      this.scroll('y', event)
    },
    scrollUp (event) {
      this.scroll('up', event)
    },
    scrollDown (event) {
      this.scroll('down', event)
    },
    scroll (type, event) {
      this.timestamps[type] = event.timeStamp
      let doit = () => {
        if (this.timestamps[type] !== event.timeStamp) return
        this.$emit('scroll-' + type, event)
      }
      setTimeout(function () { doit() }, 300)
    }
  }
}
</script>

<style scoped>
.scroll-area { height: 100%; margin: auto; position: relative; width: 100%; }
</style>

<style>
.ps > .ps__scrollbar-x-rail,
.ps > .ps__scrollbar-y-rail { background: transparent !important; border-radius: 2px; opacity: 1 !important; }
.ps > .ps__scrollbar-x-rail { background: rgba(255, 255, 255, .05) !important; bottom: 1px; height: 8px !important; opacity: 1 !important; }
.ps > .ps__scrollbar-y-rail { background: rgba(255, 255, 255, .05) !important; right: 1px; width: 8px !important; opacity: 1 !important; }
.ps > .ps__scrollbar-x-rail:hover,
.ps > .ps__scrollbar-y-rail:hover { background: rgba(255, 255, 255, .05) !important; opacity: 1 !important; }
.ps.ps--in-scrolling.ps--x > .ps__scrollbar-x-rail,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail { background: rgba(255, 255, 255, .1) !important; opacity: 1 !important; }
.ps > .ps__scrollbar-x-rail > .ps__scrollbar-x,
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y { background: rgba(0, 0, 0, .5) !important; border-radius: 2px !important; opacity: 1 !important; }
.ps > .ps__scrollbar-x-rail > .ps__scrollbar-x { bottom: 0 !important; height: 8px !important; opacity: 1 !important; }
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y { right: 0 !important; width: 8px !important; opacity: 1 !important; }
</style-->

<template>
  <vue-custom-scrollbar class="scroll-area"
    :settings="settings"
    :key="this.$route.path + this.$i18n.locale"
    @ps-scroll-x="scrollX(...arguments)"
    @ps-scroll-left="scrollLeft(...arguments)"
    @ps-scroll-right="scrollRight(...arguments)"
    @ps-scroll-y="scrollY(...arguments)"
    @ps-scroll-up="scrollUp(...arguments)"
    @ps-scroll-down="scrollDown(...arguments)"
    @ps-y-reach-start="$emit('y-start')"
    @ps-y-reach-end="$emit('y-end')">
    <slot></slot>
  </vue-custom-scrollbar>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
export default {
  components: {
    VueCustomScrollbar
  },
  data () {
    return {
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
        minScrollbarLength: 60,
        maxScrollbarLength: 60
      },
      timestamps: {
        y: null,
        up: null,
        down: null
      }
    }
  },
  methods: {
    scrollX (event) {
      this.scroll('x', event)
    },
    scrollLeft (event) {
      this.scroll('left', event)
    },
    scrollRight (event) {
      this.scroll('right', event)
    },
    scrollY (event) {
      this.scroll('y', event)
    },
    scrollUp (event) {
      this.scroll('up', event)
    },
    scrollDown (event) {
      this.scroll('down', event)
    },
    scroll (type, event) {
      this.timestamps[type] = event.timeStamp
      let doit = () => {
        if (this.timestamps[type] !== event.timeStamp) return
        this.$emit('scroll-' + type, event)
      }
      setTimeout(function () { doit() }, 300)
    }
  }
}
</script>

<style scoped>
.scroll-area { height: 100%; margin: auto; position: relative; width: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/MScrollbar.vue